<!-- 评级报告 -->
<template>
  <div class="index-info" :class="$route.query.themeStyleVs == 2 ? 'black_theme' : 'white_theme'">
    <div class="title_h1">
      <p>评级报告</p>
      <button :class="'tg' + typeInfo">
        {{
          typeInfo == 1
            ? '历史表现优秀'
            : typeInfo == 2
            ? '历史表现欠佳'
            : typeInfo == 3
            ? '历史表现一般'
            : '--'
        }}
      </button>
    </div>

    <div class="list">
      <van-row>
        <van-col span="8" class="left">最大预计年化收益：</van-col>
        <van-col span="16" class="right">
          持股{{ ReportGradeResult.MaxYearCycle }}天, 涨幅

          <span :class="[judgeColor(ReportGradeResult.MaxYearProfit)]">{{
            toFixedNum(ReportGradeResult.MaxYearProfit * 100, '2', '%')
          }}</span>
        </van-col>

        <van-col span="8" class="left">历史最大成功率：</van-col>
        <van-col span="16" class="right">
          持股{{ ReportGradeResult.MaxSuccessCycle }}天, 上涨概率
          <span :class="[judgeColor(ReportGradeResult.MaxSuccessRate)]">{{
            toFixedNum(ReportGradeResult.MaxSuccessRate * 100, '2', '%')
          }}</span>
        </van-col>

        <van-col span="8" class="left">回测周期：</van-col>
        <van-col span="16" class="right">
          {{ formatStrTime(startDate) }}
          <span class="ds-box">至</span>
          {{ formatStrTime(endDate) }}
        </van-col>
      </van-row>
    </div>

    <p class="title_h2">专业评级</p>

    <div id="radarDom"></div>
  </div>
</template>

<script>
import { judgeColor, toFixedNum, formatStrTime } from '@/utils/format';
import mixin from '@/mixins/index.js';
export default {
  name: 'Home',
  mixins: [mixin],
  props: ['RadarMapResult', 'ReportGradeResult', 'startDate', 'endDate'],
  data() {
    return {
      raderDom: null,
      typeInfo: 0 //评级报告信号类型
    };
  },
  filters: {},
  created() {},
  watch: {},
  mounted() {
    /**
     * 计算信号值
     * 历史表现优秀(1): 年化收益率>15% and 最大回撤<年化收益率
     * 历史表现欠佳(2): 年化收益率<0
     * 历史表现一般(3): 除了上面两种情况，为历史表现一般
     */
    if (
      this.ReportGradeResult.MaxYearProfit * 100 > 15 &&
      this.ReportGradeResult.MaxRetreatRate < this.ReportGradeResult.MaxYearProfit
    ) {
      this.typeInfo = 1;
    } else if (this.ReportGradeResult.MaxYearProfit * 100 < 0) {
      this.typeInfo = 2;
    } else {
      this.typeInfo = 3;
    }

    this.$nextTick(() => {
      this.raderFun();
    });
  },
  methods: {
    judgeColor,
    toFixedNum,
    formatStrTime,
    //雷达图
    raderFun: function () {
      var _this = this;
      _this.raderDom = _this.$echarts.init(document.getElementById('radarDom'));
      window.addEventListener('resize', _this.resizeRader);

      var result = [];

      Object.keys(_this.RadarMapResult).forEach(function (key) {
        var value = _this.RadarMapResult[key];
        var name = ''; // 初始化中文名称变量

        // 根据英文名称匹配对应的中文名称
        switch (key) {
          case 'ProfitAbility':
            name = '盈利能力';
            break;
          case 'StockAbility':
            name = '选股能力';
            break;
          case 'AntiRiskAbility':
            name = '抗风险能力';
            break;
          case 'Stability':
            name = '稳定性';
            break;
          case 'AbsIncome':
            name = '绝对收益';
            break;
          // 添加其他属性的对应中文名称
        }

        result.push({ name: name + value + '分', value: value, max: 100 });
      });

      var option = {
        grid: {
          width: '80%', // 设置雷达图宽度，可以使用像素值或百分比
          height: '80%' // 设置雷达图高度，可以使用像素值或百分比
        },
        color: ['#296DF7'],
        radar: {
          radius: 75,
          indicator: result,
          axisName: {
            color: _this.$route.query.themeStyleVs == 2 ? '#AAB9D1' : 'rgba(102, 102, 102, 0.90)' // 设置颜色值
          },
          splitLine: {
            lineStyle: {
              color: _this.$route.query.themeStyleVs == 2 ? '#2F3139' : '#E6E6E6' // 设置网格线颜色，
            }
          },
          axisLine: {
            lineStyle: {
              color: _this.$route.query.themeStyleVs == 2 ? '#2F3139' : '#E6E6E6'
            }
          },
          splitArea: {
            show: true, // 显示分隔区域
            areaStyle: {
              color: _this.$route.query.themeStyleVs == 2 ? '#191A24' : '#fff' // 设置分隔区域的颜色，可以设置多个颜色用来渐变
            }
          }
        },
        series: [
          {
            type: 'radar',
            symbol: 'none',
            data: [
              {
                value: Object.values(_this.RadarMapResult),
                areaStyle: {
                  color: 'rgba(59, 133, 254, 0.4)'
                }
              }
            ]
          }
        ]
      };
      _this.raderDom.setOption(option);
      window.addEventListener('resize', function () {
        _this.raderDom.resize(); //自适应
      });
    }
  }
};
</script>
<style lang="less" scoped>
.tg2 {
  background: linear-gradient(270deg, #00701e 0%, #5db688 100%);
}
.tg1 {
  background: linear-gradient(270deg, #cd0000 0%, #f76825 100%);
}
.tg3 {
  background: linear-gradient(270deg, #3a497f 0%, #99a4ce 100%);
}
.index-info {
  padding: 15px;
  .title_h1 {
    display: flex;
    align-items: center;
    justify-content: space-between;
    p {
      font-weight: 600;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.9);
    }
    button {
      border-radius: 2px;
      font-weight: 400;
      font-size: 12px;
      color: #fff;
      padding: 2px 4px;
    }
  }
  .list {
    line-height: 25px;
    margin-top: 10px;
    font-size: 12px;
    .left {
      font-weight: 400;
      color: #999;
    }
    .right {
      text-align: right;
      color: #555;
    }
  }
  .title_h2 {
    color: #666;
    font-size: 14px;
    font-weight: 400;
    margin-top: 24px;
  }
  #radarDom {
    height: 253px;
  }
}
</style>

<!-- 黑色主题 -->
<style lang="less" scoped>
.black_theme {
  .title_h1 {
    p {
      color: #e4e9fe;
    }
  }
  .title_h2 {
    color: #e4e9fe;
  }
  .list {
    .left {
      color: #6b7687;
    }
    .right {
      color: #e4e9fe;
    }
  }
}
</style>
